import template from './print_tankers.html';
import controller from './print_tankers.controller';
import './print_tankers.scss';

let printTankersComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printTankersComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tankers/print/print_tankers.component.js